if (!customElements.get("m-brand-list")) {
  class MBrandList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      const wrapper = this.querySelector("[data-wrapper]");
      wrapper.classList.add("swiper-wrapper");
      this.initSlider();
    }

    initSlider() {
  const items = parseInt(this.dataset.items);
  const slideContainer = this.querySelector(".swiper-container");
  if (!slideContainer) return;

  // If theme editor re-renders, prevent double init
  if (this.slider && this.slider.destroy) {
    try { this.slider.destroy(true, true); } catch(e) {}
  }

  this.slider = new MinimogLibs.Swiper(slideContainer, {
    // ✅ Continuous motion settings
    loop: true,
    loopAdditionalSlides: 50,
    watchOverflow: false,

    speed: 9000, // higher = slower continuous crawl
    autoplay: {
      delay: 0, // ✅ no pauses
      disableOnInteraction: false,
    },

    freeMode: true,
    freeModeMomentum: false,

    // ✅ 3 logos on mobile
    slidesPerView: 3,
    spaceBetween: 12,

    // arrows
    navigation: {
      nextEl: this.querySelector(".swiper-button-next"),
      prevEl: this.querySelector(".swiper-button-prev"),
    },

    // pagination (optional; you can remove if you don’t want dots)
    pagination: {
      el: this.querySelector(".swiper-pagination"),
      clickable: true,
    },

    breakpoints: {
      768: {
        slidesPerView: items > 3 ? 3 : items,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: items,
        spaceBetween: 30,
      },
    },
  });
}

  }

  customElements.define("m-brand-list", MBrandList);
}
